import { AlterResponse } from "../../models/AlterView";
import { View } from "../View";

export default class Q9 extends View {
    render() {
        return (
            <div className="Q9">
                <h2>Les sujets n'obéissent plus, il faut les punir !<br/>La Machine tue :</h2>
                <hr />
                <div className="btn-group btn-group-3">
                    <button onClick={ () => this.props.onFinish(AlterResponse.SUBJECT_1) }>Le sujet féminin</button>
                    <button onClick={ () => this.props.onFinish(AlterResponse.SUBJECT_2) }>Le sujet masculin</button>
                    <button onClick={ () => this.props.onFinish(AlterResponse.NEITHER) }>Aucun des deux</button>
                </div>
            </div>
        );
    }
}
